/**
 * Routes of the legal protection (PJ) subscription funnel, defined once for every consumer
 * (step configs, step-route mapping tables, imperative navigations).
 */

/** Base routes without the trailing risk id (createStepConfig appends `/${riskId}` itself). */
export const LEGAL_PROTECTION_ROUTES = {
  registration: "/simulation/inscription/pj",
  // Generic pricing page (PricingProcess), driven by the risk id: no dedicated PJ route.
  pricing: "/simulation/tarification",
} as const;

/**
 * Same routes as templates with the `:riskId` param, for the step-route mapping tables.
 * No eligibility entry: the ELIGIBILITY sub-step leads to the registration page, which carries
 * the verdict.
 */
export const LEGAL_PROTECTION_ROUTE_TEMPLATES = {
  registration: `${LEGAL_PROTECTION_ROUTES.registration}/:riskId`,
  pricing: `${LEGAL_PROTECTION_ROUTES.pricing}/:riskId`,
} as const;

/** Labels of the legal protection steps in the step-route mapping tables. */
export const LEGAL_PROTECTION_ROUTE_LABELS = {
  registration: "Gérer la société",
  pricing: "Tarification",
} as const;
